import {
  Alert,
  Box,
  Button,
  Link,
  MenuItem,
  Menu,
  Typography,
} from '@mui/material';
import {styled} from '@mui/system';

import {ZmMenu} from '../ZmDialogs';

import {ZmTertiaryBtn} from 'Components/ZmButtons';
import {getTextOverflowStyle} from 'Utils';
import zoomPalette from 'zoomPalette';

export const LoadingContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '400px',
  width: '100vw',
}));

export const EventContainer = styled(Box)(({theme}) => ({
  ...({...theme,
    '& .refresh-appts-btn': {
      animation: 'spin 2s infinite',
    },
  } || {}),
}));

export const MostRecentLinkAlert = styled(Alert)(({theme}) => ({
  'background': zoomPalette.blue[10],
  'borderRadius': '10px',
  'marginBottom': '15px',
  '.MuiAlert-message': {
    width: '90%',
  },
  '.MuiSvgIcon-root': {
    color: zoomPalette.gray[90],
  },
}));

export const AppointmentsListContainer = styled('div')(({theme}) => ({
  'marginTop': '15px',
  'marginBottom': '24px',
}));

export const ApptItemContainer = styled('div')(({disabled, theme}) => ({
  'boxSizing': 'border-box',
  'position': 'relative',
  'padding': '12px',
  'transitionDuration': '200ms',
  'transitionProperty': 'box-shadow, background',

  'background': '#FFFFFF',
  'color': theme.palette.common.swatch['90'],
  'border': `1px solid ${theme.palette.common.swatch['30']}`,
  '&:hover .assignToItem': {
    borderColor: zoomPalette.blue[20],
    background: zoomPalette.blue[10],
    color: zoomPalette.blue[70],
  },
  ...(disabled) ? {
    cursor: 'default',
  } : {
    'cursor': 'pointer',
    '&:hover': {
      background: theme.palette.common.swatch['10'],
      boxShadow: '0px 4px 8px rgba(19, 22, 25, 0.1), 0px 2px 4px rgba(19, 22, 25, 0.1)',
    },
    '&:active': {
      background: theme.palette.common.swatch['20'],
    },
  },
  '&.Mui-disabled': {
    color: theme.palette.common.swatch['60'],
    background: theme.palette.white,
  },

  'borderRadius': '6px',

  'display': 'flex',
  'flexDirection': 'column',
  'flex': 'none',
  'flexGrow': '0',
  'justifyContent': 'space-between',
  'overflow': 'hidden',
  'height': '226px',
  'minWidth': '220px',
  '&[data-active="false"]': {
    filter: 'grayscale(100%)',
  },
}));

export const ApptItemContainerEmpty = styled('div')(({theme}) => ({
  height: '226px',
  minWidth: '220px',
  borderRadius: '12px',
  border: `1px dashed ${theme.palette.common.swatch['30']}`,

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  marginBottom: '8px',
  marginRight: '8px',
  overflow: 'hidden',

  cursor: 'pointer',
}));

export const CardActionMenu = styled((props) =>
  <ZmMenu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  >
    {props.children}
  </ZmMenu>
)(({theme}) => ({
  'marginTop': '2px',
  '& .MuiPaper-root': {
    'padding': '8px',
    'minWidth': '120px',
    '& .MuiMenuItem-root': {
      'padding': '6px 8px',
      '&:hover': {
        backgroundColor: `${theme.palette.common.swatch['20']}`,
        color: `${theme.palette.common.black}`,
      },
      '& + .MuiDivider-root': {
        margin: 0,
      },
      'borderRadius': '4px',
    },
  },
}));

export const StyledButton = styled(Button)(({theme}) => ({
  'color': zoomPalette.gray[90],
  'background': zoomPalette.white,
  // 'flexGrow': 1,
  'height': '32px',
  'fontSize': '14px',
  'fontWeight': 'normal',
  'borderRadius': '6px',
  'border': `none !important`,
  'padding': '6px 8px',
  '&:hover': {
    background: `${theme.palette.common.swatch['10']}`,
  },
  '&.isActive': {
    color: zoomPalette.white,
    background: zoomPalette.blue[60],
  },
}));

export const CustomLink = styled(Link)(({theme}) => ({
  color: zoomPalette.blue[70],
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '200px',
  marginLeft: '10px',
}));

export const LearnMoreLink = styled(Link)(({theme}) => ({
  color: 'inherit',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '200px',
  marginLeft: '10px',
}));

export const MoreOptionsMenuItem = styled(Box)(({theme}) => ({}));

export const HeaderContainer = styled(Box)(({hasHostsValidationErr, isActive, theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  ...(!isActive || hasHostsValidationErr) && {
    color: 'gray',
    borderColor: 'gray',
  },
}));
export const BodyContainer = styled(Box)(({hasHostsValidationErr, isActive, theme}) => ({
  marginTop: '10px',
  flexGrow: 1,
  overflowY: 'auto',
  width: '100%',
  ...(!isActive || hasHostsValidationErr) && {
    color: 'gray',
  },
}));

export const MoreOptionsZmMenu = styled(Menu)(({theme}) => ({
  '& .MuiPaper-root': {
    'borderRadius': 8,
    'boxShadow': '0px 12px 24px rgba(19, 22, 25, 0.1), 0px 6px 12px rgba(19, 22, 25, 0.1)',
    '& .MuiMenuItem-root': {
      'height': '24px',
      'fontSize': '14px',
      'padding': '4px 8px',
      '& .MuiBox-root .MuiBox-root .MuiSvgIcon-root': {
        marginRight: '8px',
      },
      '& .MuiSvgIcon-root': {
        marginRight: 0,
      },
    },
    '& .more-options-menu': {
      'padding': '4px 8px',
      'height': '32px',
      'color': zoomPalette.gray['90'],
      'cursor': 'pointer',
      'minWidth': '220px',
      'a': {
        'height': '100%',
        'display': 'inline-block',
        'width': '100%',
        'color': 'inherit',
        'lineHeight': '24px',
      },
      '&:hover': {
        'backgroundColor': zoomPalette.blue['60'],
        'color': zoomPalette.white,
      },
    },
  },
}));

export const CustomMenuItem = styled(MenuItem)(({theme}) => ({
  'height': '32px',
  'borderRadius': '8px',
}));

export const CustomZmMenu = styled(ZmMenu)(({theme}) => ({
  '& .MuiPaper-root': {
    padding: '4px',
    marginTop: '4px',
  },
}));

export const ColorBar = styled(Box)(({color}) => ({
  backgroundColor: color,
  height: 7,
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
}));

export const TypographyHeader = styled(Typography)(({theme}) => ({
  'margin': 0,
  'marginTop': '2px',
  'fontSize': '1rem',
  'fontWeight': 510,
  'lineHeight': '1.25rem',
  'paddingRight': '4px',
  ...getTextOverflowStyle(4),
}));

export const ShowMoreContainer = styled(Box)(({gridColumnStart}) => ({
  marginTop: '4px',
  width: '100%',
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  gridColumnStart: gridColumnStart,
}));

export const MoreButton = styled(ZmTertiaryBtn)(() => ({
  'padding': 0,
  'border': 0,
  '&:hover': {
    border: `1px solid ${zoomPalette.blue[50]}`,
  },
}));
